import { usePlatformInfo } from './usePlatformInfo'
import { StatusBar, Style } from '@capacitor/status-bar'
import {
  NavigationBar,
  NavigationBarColor,
} from '@capgo/capacitor-navigation-bar'

export enum BarBackgroundStyle {
  PRIMARY = 'primary',
  WHITE = 'white',
}

export interface NativeStyleOptions {
  statusBar: BarBackgroundStyle
  navigationBar: BarBackgroundStyle
}

const { isAndroid, isWeb } = usePlatformInfo()

export function useNativeStyle() {
  const adaptNativeStyle = async (options: NativeStyleOptions) => {
    if (isWeb) return

    if (isAndroid) {
      await StatusBar.setOverlaysWebView({ overlay: true })
      await StatusBar.setBackgroundColor({
        color: '#00000000',
      })
    }

    await StatusBar.setStyle({
      style:
        options.statusBar === BarBackgroundStyle.PRIMARY
          ? Style.Dark
          : Style.Light,
    })

    if (isAndroid) {
      await NavigationBar.setNavigationBarColor({
        color: NavigationBarColor.TRANSPARENT,
        darkButtons: options.navigationBar === BarBackgroundStyle.WHITE,
      })
    }
  }

  return {
    adaptNativeStyle,
  }
}
